import React, { useEffect, useRef, useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { brandAssets } from "../data/site";
export function VideoIntro() {
  const reduceMotion = useReducedMotion();
  const skipButtonRef = useRef<HTMLButtonElement>(null);
  const [visible, setVisible] = useState(true);
  useEffect(() => {
    if (reduceMotion) setVisible(false);
  }, [reduceMotion]);
  useEffect(() => {
    if (!visible) return;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [visible]);
  function dismiss() {
    setVisible(false);
  }
  function handleKeyDown(event: React.KeyboardEvent<HTMLDivElement>) {
    if (event.key === "Escape") dismiss();
    if (event.key === "Tab") {
      event.preventDefault();
      skipButtonRef.current?.focus();
    }
  }
  return <AnimatePresence data-id="element-260" data-mp="cjddjipup99x">
      {visible ? <motion.div className="fixed inset-0 z-[100] grid place-items-center overflow-hidden bg-black" initial={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.22, 1, 0.36, 1]
    }} role="dialog" aria-modal="true" aria-label="Leo Tovar Method introduction" onKeyDown={handleKeyDown} data-id="element-261" data-mp="1pcw0wdi3k2b2">
          <video className="h-full w-full object-contain" src={brandAssets.introVideo} autoPlay muted playsInline preload="auto" onEnded={dismiss} onError={dismiss} aria-label="Leo Tovar Method video introduction" data-id="element-262" data-mp="28bi01mu1zjcc" />
          <button ref={skipButtonRef} type="button" autoFocus onClick={dismiss} className="absolute right-5 top-5 min-h-11 border border-white/30 bg-black/60 px-4 py-2 text-[10px] font-bold uppercase tracking-[0.2em] text-white transition-[background-color,border-color] duration-200 ease-out hover:border-white hover:bg-black focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-white sm:right-8 sm:top-8" data-id="element-263" data-mp="2d3i5fusw74gb">
            Skip intro
          </button>
        </motion.div> : null}
    </AnimatePresence>;
}